export const datazproducts = [
    {
        id:1,
        imageUrl:"https://static-01.daraz.com.np/p/8304ca7058b30da519751aec1e3f6c51.jpg_200x200q90-product.jpg_.webp",
        title:"Handy Stitch Portable Sewing Machine",
        price: "Rs.499",
        expectedprice:"Rs. 1199",
        discount:"-58%",
        mall:false,
        rating: {
            star:4,
            review:222,
        },
    },
    {
        id:2,
        imageUrl:"https://static-01.daraz.com.np/p/6dc6d5898e42e66276ccd2582dbcc82d.jpg_200x200q90-product.jpg_.webp",
        title:"Head Massage Device Perfect Device Hard...",
        price: "Rs. 98",
        expectedprice:"Rs.100",
        discount:"-2%",
        mall:false,
        rating: {
            star:4,
            review:122,
        },
    },
    {
        id:3,
        imageUrl:"https://static-01.daraz.com.np/p/8b1e52fb72965ee61af0afdb2c8bf3b3.jpg_200x200q90-product.jpg_.webp",
        title:"Multiple Cereal Dispenser Container Wall Mounted...",
        price: "Rs.1699",
        expectedprice:"Rs.2500",
        discount:"-32%",
        mall:false,
        rating: {
            star:3,
            review:25,
        },
    },
    {
        id:4,
        imageUrl:"https://static-01.daraz.com.np/p/53f13dc4db83d2af4c5fe08d1df6d46f.jpg_200x200q90-product.jpg_.webp",
        title:"Folding Sunglasses For Unisex",
        price: "Rs.240",
        expectedprice:"Rs 600",
        discount:"-60%",
        mall:false,
        rating: {
            star:5,
            review:321,
        },
    },
    {
        id:5,
        imageUrl:"https://static-01.daraz.com.np/p/30cfbecd993e4cec030e54f029149a2c.jpg_200x200q90-product.jpg_.webp",
        title:"SmartWatch Band for Apple Watch and Other 42/44m...",
        price: "Rs.175",
        expectedprice:"Rs.200",
        discount:"-13%",
        mall:false,
        rating: {
            star:4,
            review:12,
        },
    },
    {
        id:6,
        imageUrl:"https://static-01.daraz.com.np/p/75b47ab4e3b376354eb6a5393efe65de.jpg_200x200q90-product.jpg_.webp",
        title:"Stand Phone Holder Wall Mounted Mobile Charging...",
        price: "Rs. 95",
        expectedprice:"Rs.249",
        discount:"-62%",
        mall:false,
        rating: {
            star:4,
            review:10,
        },
    },
    {
        id:7,
        imageUrl:"https://static-01.daraz.com.np/p/77001561774aaa33cf4a27f13b7f2f12.jpg_200x200q90-product.jpg_.webp",
        title:"Steel Chopsticks 1 Pair",
        price: "Rs. 45",
        expectedprice:"Rs. 99",
        discount:"-55%",
        mall:false,
        rating: {
            star:5,
            review:112,
        },
    },
    {
        id:8,
        imageUrl:"https://static-01.daraz.com.np/p/3c5a7748e67c2adde2e5e2a6fd003b91.jpg_200x200q90-product.jpg_.webp",
        title:"Gold Plated Panchadhatu Letter A Free Size Ring For...",
        price: "Rs. 520",
        expectedprice:"Rs. 600",
        discount:"-29%",
        mall:false,
        rating: {
            star:5,
            review:224,
        },
    },
    {
        id:9,
        imageUrl:"https://static-01.daraz.com.np/p/43cda40d7c627a127bb314a3fb9d91ce.jpg_200x200q90-product.jpg_.webp",
        title:"Jewels of Nepal Knot Designed Floral Patterned...",
        price: "Rs. 225",
        expectedprice:"Rs300",
        discount:"-31%",
        mall:true,
        rating: {
            star:5,
            review:140,
        },
    },
    {
        id:10,
        imageUrl:"https://static-01.daraz.com.np/p/0bd6f59cbd97a3051950c7e0c7fd58ff.jpg_200x200q90-product.jpg_.webp",
        title:"Cotton Boxer For Men (Pack Of 3)",
        price: "Rs. 1,199",
        expectedprice:"Rs.1450",
        discount:"-17%",
        mall:false,
        rating: {
            star:4,
            review:124,
        },
    },
    {
        id:11,
        imageUrl:"https://static-01.daraz.com.np/p/488ae9e659a82e89c5e9298af8ce0355.jpg_200x200q90-product.jpg_.webp",
        title:"VGR V-085 SUPER TRIM PRofessional Hair Trimmer...",
        price: "Rs.1,800",
        expectedprice:"Rs.2500",
        discount:"-28%",
        mall:false,
        rating: {
            star:5,
            review:111,
        },
    },
    {
        id:12,
        imageUrl:"https://static-01.daraz.com.np/p/39a637c5a6c7918e94deff6bd824851b.jpg_200x200q90-product.jpg_.webp",
        title:"Wallnut 1kg/Okhar -1kg Organic & Soft -by Sarga...",
        price: "Rs. 620",
        expectedprice:"Rs.680",
        discount:"-9%",
        mall:false,
        rating: {
            star:5,
            review:120,
        },
    },
    {
        id:13,
        imageUrl:"https://static-01.daraz.com.np/p/731019929192dcc5c6a689b8f5ee5edf.jpg_200x200q90-product.jpg_.webp",
        title:"Bell Designed Traditional Key Holder/Mask...",
        price: "Rs.1850",
        expectedprice:"Rs.2300",
        discount:"-20%",
        mall:false,
        rating: {
            star:5,
            review:130,
        },
    },
    {
        id:14,
        imageUrl:"https://static-01.daraz.com.np/p/a4c69d765f3c7b05a5ce2d8a937e51bb.jpg_200x200q90-product.jpg_.webp",
        title:"Automatic Universal Tootpaste Dispenser An..",
        price: "Rs.250",
        expectedprice:"Rs.500",
        discount:"50%",
        mall:false,
        rating: {
            star:5,
            review:212,
        },
    },
    {
        id:15,
        imageUrl:"https://static-01.daraz.com.np/p/d568e2b1efe60a8d2a38c8803a349c67.jpg_200x200q90-product.jpg_.webp",
        title:"Buddha Back Flow Smoke Fountain Scented Cone...",
        price: "Rs.335",
        expectedprice:"Rs.1000",
        discount:"-67%",
        mall:true,
        rating: {
            star:5,
            review:210,
        },
    },
    {
        id:16,
        imageUrl:"https://static-01.daraz.com.np/p/156d9408fef4cb14910f1e1b0f5e0ce0.jpg_200x200q90-product.jpg_.webp",
        title:"Fashionable Simple Thick-Edged Sunglasses...",
        price: "Rs.399",
        expectedprice:"Rs.900",
        discount:"-56%",
        mall:false,
        rating: {
            star:5,
            review:88,
        },
    },
    {
        id:17,
        imageUrl:"https://static-01.daraz.com.np/p/391672004a239325f818e569df8e3c00.jpg_200x200q90-product.jpg_.webp",
        title:"Mickey Minnie Regular Cotton Tshirt for Ladies",
        price: "Rs.499",
        expectedprice:"Rs.750",
        discount:"-33%",
        mall:false,
        rating: {
            star:5,
            review:144,
        },
    },
    {
        id:18,
        imageUrl:"https://static-01.daraz.com.np/p/a72935c61263269def0e09c29a2c913a.jpg_200x200q90-product.jpg_.webp",
        title:"Shockproof Clear Phone Case For iPhone 6 Plus /...",
        price: "Rs.189",
        expectedprice:"Rs.299",
        discount:"-37%",
        mall:false,
        rating: {
            star:5,
            review:242,
        },
    },
    {
        id:19,
        imageUrl:"https://static-01.daraz.com.np/p/d73bd58ad662d0c0070c99ef6c50b5f6.jpg_200x200q90-product.jpg_.webp",
        title:"Butterfly Hoop Earring Pendant Necklace For...",
        price: "Rs. 145",
        expectedprice:"Rs. 200",
        discount:"-32%",
        mall:false,
        rating: {
            star:4,
            review:123,
        },
    },
    {
        id:20,
        imageUrl:"https://static-01.daraz.com.np/p/29bb2d3ae35f2ae9cd2088b6055c4098.jpg_200x200q90-product.jpg_.webp",
        title:"Waterproof Washing Machine Heavy Cover 6-1..",
        price: "Rs. 546",
        expectedprice:"Rs.900",
        discount:"-39%",
        mall:true,
        rating: {
            star:4,
            review:159,
        },
    },
    {
        id:21,
        imageUrl:"https://static-01.daraz.com.np/p/b1b0fb3e5c5b805b58dbdeac3b65aea6.jpg_200x200q90-product.jpg_.webp",
        title:"Big Display Digital Black Rubber Strap Sports Watch..",
        price: "Rs.650",
        expectedprice:"Rs.1400",
        discount:"-54%",
        mall:false,
        rating: {
            star:4,
            review:189,
        },
    },
    {
        id:22,
        imageUrl:"https://static-01.daraz.com.np/p/bbbac348647661ebb79c43de7095d450.jpg_200x200q90-product.jpg_.webp",
        title:"Maybelline Superstay MatteLip Crayon Style Exception...",
        price: "Rs.1660",
        expectedprice:"Rs. 1780",
        discount:"-8%",
        mall:true,
        rating: {
            star:5,
            review:185,
        },
    },
    {
        id:23,
        imageUrl:"https://static-01.daraz.com.np/p/a39e86a47eeaf618bfb95f5a22b9a3ed.jpg_200x200q90-product.jpg_.webp",
        title:"Ms Dual Color Windcheater Men",
        price: "Rs.1199",
        expectedprice:"Rs.1799",
        discount:"-33%",
        mall:true,
        rating: {
            star:5,
            review:199,
        },
    },
    {
        id:24,
        imageUrl:"https://static-01.daraz.com.np/p/012fbc966a491b3d214c528b2ea87d89.jpg_200x200q90-product.jpg_.webp",
        title:"Guanwan Disposable Mask -3 Ply -50Pcs",
        price: "Rs.125",
        expectedprice:"Rs.600",
        discount:"-79%",
        mall:false,
        rating: {
            star:4,
            review:99,
        },
    },
    
]